import type { UnitDefinition } from "@src/types/units";

/**
 * Match the active-timeseries node unit (a number) against the catalog: by
 * unit_id (units-map key) or external_reference — both are plausible sources
 * of the node's unit number.
 */
export const findUnitByReference = (
  units: Record<string, UnitDefinition>,
  reference: number | string | null,
): UnitDefinition | null =>
  reference == null
    ? null
    : Object.values(units).find(
        (u) =>
          u.unit_id === String(reference) ||
          u.external_reference === String(reference),
      ) ?? null;
